import i18n from '@/i18n';

const t = (key: string) => i18n.global.t(key);

export default (_ctx?: any) => [
  {
    name: 'reports-visits',
    title: t('Visits'),
    value: 0
  },
  {
    name: 'reports-clicks',
    title: t('Clicks'),
    value: 0
  },
  {
    name: 'reports-conversionconfirm',
    title: t('Conversions'),
    value: 0
  },
  {
    name: 'reports-revenue',
    title: t('Revenue'),
    value: 0
  },
  {
    name: 'reports-cost',
    title: t('Cost'),
    value: 0
  },
  {
    name: 'reports-profit',
    title: t('Profit'),
    value: 0
  },
  {
    name: 'reports-roi',
    title: t('ROI'),
    value: 0
  }
];